import request from '@/utils/request'


// 查询积分/金币兑换记录列表
export function listDuihuanJilu(query) {
  return request({
    url: '/zb/duihuan/jilu/list',
    headers: { 'repeatSubmit': false },
    method: 'post',
    data: query
  })
}

// 查询积分/金币兑换记录分页
export function pageDuihuanJilu(query) {
  return request({
    url: '/zb/duihuan/jilu/page',
    method: 'post',
    headers: { 'repeatSubmit': false },
    data: query
  })
}

// 查询积分/金币兑换记录详细
export function getDuihuanJilu(data) {
  return request({
    url: '/zb/duihuan/jilu/detail',
    method: 'get',
    params: data
  })
}

// 新增积分/金币兑换记录
export function addDuihuanJilu(data) {
  return request({
    url: '/zb/duihuan/jilu/add',
    method: 'post',
    data: data
  })
}

// 修改积分/金币兑换记录
export function updateDuihuanJilu(data) {
  return request({
    url: '/zb/duihuan/jilu/edit',
    method: 'post',
    data: data
  })
}

// 删除积分/金币兑换记录
export function delDuihuanJilu(data) {
  return request({
    url: '/zb/duihuan/jilu/delete',
    method: 'post',
    data: data
  })
}
